import qs from 'query-string'
import { useHistory, useLocation } from 'react-router-dom'
import { useQuery } from '@apollo/react-hooks'

import ACCOUNT_QUERY from '../../../../../../graphql/queries/account.gql'
import { modalContent } from '../../../../../modules/shared/subscription-constants'
import { MODALS } from '../../../../../constants'
import { useIsAuthenticated } from '../../../../../hooks/use-is-authenticated'
import { useFeatureFlags } from '../../../../../hooks/useFeatureFlags'
import { usePlanChangeFlag } from '../../../../../hooks/usePlanChange'

export const useWelcomeBack = () => {
  const history = useHistory()
  const location = useLocation()
  const isAuthenticated = useIsAuthenticated()

  const flags = useFeatureFlags(['discount_basic', 'discount_standard', 'discount_annual'])
  const planDetails = usePlanChangeFlag()
  const showBasicDiscount = flags.discount_basic
  const showStandardDiscount = flags.discount_standard
  const showAnnualDiscount = flags.discount_annual
  const isShowingDiscount = showBasicDiscount || showStandardDiscount || showAnnualDiscount

  const { data: accountData } = useQuery(ACCOUNT_QUERY, {
    fetchPolicy: 'cache-only',
    skip: !isAuthenticated
  })

  const defaultProfile = accountData?.account?.profiles?.find(
    profile => profile.isDefault
  )

  // Checks whether the default profile is missing required information
  const isDefaultProfileIncomplete =
    defaultProfile &&
    (defaultProfile.birthYear === null || defaultProfile.gender === null)

  const generalMsg = {
    header: 'Welcome back!',
    msg: isDefaultProfileIncomplete
      ? 'Finish setting up your account and add a plan to start watching.'
      : 'Add a plan to start watching.'
  }
  const headerAndCopy = []
  // when we have promotional price(controlled by FF), we use special msg, otherwise general msg
  if (isShowingDiscount) {
    if (showBasicDiscount) {
      headerAndCopy.push({
        header: planDetails.basic.discountWelcomeBackHeader,
        msg: planDetails.basic.discountWelcomeBackMessage
      })
    }
    if (showStandardDiscount) {
      headerAndCopy.push({
        header: planDetails.standard.discountWelcomeBackHeader,
        msg: planDetails.standard.discountWelcomeBackMessage
      })
    }
    if (showAnnualDiscount) {
      headerAndCopy.push({
        header: planDetails.annual.discountWelcomeBackHeader,
        msg: planDetails.annual.discountWelcomeBackMessage
      })
    }
  } else {
    headerAndCopy.push(generalMsg)
  }

  const confirmText = isDefaultProfileIncomplete
    ? 'Finish Sign Up'
    : 'Choose plan'

  const handleConfirm = () => {
    // Always open the add-subscription modal
    // If `isDefaultProfileIncomplete` is true, the account details modal will be shown in the payment pre-step
    history.replace({
      ...location,
      search: qs.stringify({
        content: modalContent.selection,
        modal: MODALS.qsParams.addSubscription
      })
    })
  }

  return {
    accountData,
    isDefaultProfileIncomplete,
    headerAndCopy,
    confirmText,
    handleConfirm
  }
}
